export default __webpack_public_path__ + "static/gradient-ebd12ef0466f5a528ac34423e32e65c4.png";